import {
  ISignedDocumentTemplate,
  ISignedDocumentTemplateCreateRequest
} from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { useWSMutation } from "@ws-react-query";

import { useMutationCreateSignedDocumentTemplate } from "../../../../../query/signedDocuments/mutations/useMutationCreateSignedDocumentTemplate";
import {
  helloSignClient,
  helloSignPromise
} from "../../../../../utils/helloSign";

export const useMutationCreateSignatureRequirementDefinitionDataSource = () => {
  const [createSignedDocumentTemplate] =
    useMutationCreateSignedDocumentTemplate();

  return useWSMutation(
    async (
      formValues: ISignedDocumentTemplateCreateRequest
    ): Promise<ISignedDocumentTemplate> => {
      // create a template
      const template = await createSignedDocumentTemplate({
        fileId: formValues.fileId,
        roles: formValues.roles,
        title: formValues.title,
        userId: formValues.userId
      });

      // open hello sign modal
      helloSignClient.open(template?.editUrl as string);

      const status = await helloSignPromise();

      if (status === "closed" && template?.signedDocumentTemplateId) {
        // open confirmation modal to create requirement

        return template;
      }

      throw Error("Something went wrong!");
    }
  );
};
